import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

const ID_TOKEN_KEY = 'GLSID';
const TOKEN_MAX_AGE = 60 * 60 * 24 * 1; // one day

@Injectable()
export class JwtService {
  constructor() {}

  getToken(): string {
    // eslint-disable-next-line
    const cookie = document.cookie.split(';').find((item) => item.trim().startsWith(ID_TOKEN_KEY));
    if (cookie) {
      const token = cookie.split('=')[1];
      return token;
    }
    return null;
  }

  saveToken(token: string): void {
    // eslint-disable-next-line
    console.info('setting session...');
    // eslint-disable-next-line
    document.cookie = `${ID_TOKEN_KEY}=${token ? token : ''}; max-age=${TOKEN_MAX_AGE}; domain=${
      environment.DOMAIN
    }; path=/; SameSite=None; Secure`;
  }

  destroyToken(): void {
    // eslint-disable-next-line
    document.cookie = `${ID_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${environment.DOMAIN}; SameSite=None; Secure`;
  }

  getTokenData(token: string): any {
    if (!token) return {};
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      // eslint-disable-next-line
      return JSON.parse(jsonPayload);
    } catch (error) {
      return {};
    }
  }
}
